var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhotoAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#EEF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1923 37C14.5778 37 14.0588 36.7883 13.6353 36.3648C13.2118 35.9413 13 35.4223 13 34.8078V15.1923C13 14.5778 13.2118 14.0588 13.6353 13.6353C14.0588 13.2118 14.5778 13 15.1923 13H34.8078C35.4223 13 35.9413 13.2118 36.3648 13.6353C36.7883 14.0588 37 14.5778 37 15.1923V34.8078C37 35.4223 36.7883 35.9413 36.3648 36.3648C35.9413 36.7883 35.4223 37 34.8078 37H15.1923ZM15.1923 35.7306H34.8078C35.0385 35.7306 35.25 35.6345 35.4423 35.4423C35.6345 35.25 35.7306 35.0385 35.7306 34.8078V15.1923C35.7306 14.9615 35.6345 14.75 35.4423 14.5577C35.25 14.3655 35.0385 14.2694 34.8078 14.2694H15.1923C14.9615 14.2694 14.75 14.3655 14.5577 14.5577C14.3655 14.75 14.2694 14.9615 14.2694 15.1923V34.8078C14.2694 35.0385 14.3655 35.25 14.5577 35.4423C14.75 35.6345 14.9615 35.7306 15.1923 35.7306Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6697 23.7588L35.6115 28.2727C35.8754 28.4732 36.2518 28.4217 36.4522 28.1579C36.6527 27.894 36.6013 27.5176 36.3374 27.3172L31.3212 22.7468C30.8606 22.3969 30.2077 22.4635 29.8273 22.8991L23.4187 29.0922L19.8967 25.9868C19.4496 25.5926 18.7699 25.6262 18.3639 26.0626L13.4333 31.3623C13.2076 31.6049 13.2213 31.9846 13.4639 32.2103C13.7065 32.436 14.0861 32.4223 14.3118 32.1797L19.1761 26.9513L22.7004 30.0587C23.1576 30.4618 23.8555 30.4163 24.2564 29.9572L30.6697 23.7588Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhotoAttach);
export default __webpack_public_path__ + "static/media/Icon_photo_attach.40d689ed21cf3a840f630746f94beefe.svg";
export { ForwardRef as ReactComponent };